"use strict";
/**
 *
 * https://www.irs.gov/pub/irs-pdf/p4757.pdf
 *
 * A tax processing number, issued by the IRS, for certain resident and non-resident aliens,
 * their spouses, and dependents;
 *
 * All valid ITINs are a nine-digit number in the same formatas the SSN (9XX-8X-XXXX),
 * begins with a “9” and the 4th and 5th digits range from. Effective April 12, 2011, the
 * valid range of digits are 70 to 88, 90 to 92, and 94 to 99.
 *
 * Individual Taxpayer Identification Numbers (ITINs) that haven’t been included on
 * a U.S. federal tax return at least once in the last three consecutive tax years will expire.
 *
 */
exports.__esModule = true;
exports.isValidITIN = void 0;
var ITIN_MAX_LENGTH = 11;
var isValidITIN = function (itin) {
    var hasCorrectLength = itin.length === ITIN_MAX_LENGTH;
    if (!hasCorrectLength) {
        return false;
    }
    var itinValidationExpression = /^(9\d{2})[- ]{0,1}((7[0-9]{1}|8[0-8]{1})|(9[0-2]{1})|(9[4-9]{1}))[- ]{0,1}(\d{4})$/;
    var itinFormat = /^(?:\d{3})-(?:\d{2})-(\d{4})$/;
    return itinValidationExpression.test(itin) && itinFormat.test(itin);
};
exports.isValidITIN = isValidITIN;
